import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_project_gallery = async (gallery) => {
  try {
    let data = new FormData();
    data.append("image", gallery?.image[0]);
    data.append("name", gallery?.name);
    data.append("status", gallery?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/create-project-gallery`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const update_project_gallery = async (gallery) => {
  try {
    let data = new FormData();
    data.append("id", gallery?.id);
    data.append("image", gallery?.image[0]);
    data.append("name", gallery?.name);
    data.append("status", gallery?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/update-project-gallery`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_project_gallery = async (gallery) => {
  try {
    const data = {
      id: gallery?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-project-gallery`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_all_project_gallaries = async (gallery) => {
  try {
    const data = {
      search: gallery?.search,
      sort: gallery?.sort,
      status: gallery?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-project-gallaries`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

export {
  create_project_gallery,
  update_project_gallery,
  get_project_gallery,
  get_all_project_gallaries,
};
